import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * Delete item command
 *
 * @class DeleteItemCommand
 * @extends AbstractCommand
 */
export default class DeleteItemCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {SelectionCollection} selection
     * @param {EditorItemFilter} itemFilter
     */
    constructor(selection, itemFilter) {
        super();
        this.selection = selection;
        this.items = itemFilter.filterItems(selection.toArray());
    }

    /**
     * Is this a valid command?
     *
     * @return {boolean}
     */
    isValid() {
        return this.items.length > 0;
    }

    /**
     * Execute command
     */
    execute() {
        if (!this.isValid()) return;

        this.selection.clear();

        this.items.forEach(item => item.getParentItem().getItems().remove(item));
    }

    /**
     * Unexecute command
     */
    unexecute() {
        if (!this.isValid()) return;

        this.items.forEach(item => item.getParentItem().getItems().add(item));
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Delete ${this.items.length > 1 ? 'items' : this.items[0].attributes.type}`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.DeleteItemCommand = DeleteItemCommand;
